import { FormattedMessage } from "react-intl";

import { DamageType } from "__graphql__/types";
import { Button } from "ui/Button/Button";
import { DropDown } from "ui/DropDown/DropDown";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

import { DAMAGE_TYPE_OPTIONS } from "../../utils/constants";

type BatteryStatusReasonModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onClickPrimary: () => void;
  onClickSecondary: () => void;
  setSelectedReason: (reason: DamageType) => void;
  selectedReason: null | DamageType;
};

export function BatteryStatusReasonModal({
  isOpen,
  onClose,
  onClickPrimary,
  onClickSecondary,
  setSelectedReason,
  selectedReason,
}: BatteryStatusReasonModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content maxW="295px" pt="s300" px="s200" pb="s200">
        <Modal.Body p="0">
          <HeaderS textAlign="center">
            <FormattedMessage id="pages.inventory.battery-management.modals.battery-damaged-reason.title" />
          </HeaderS>
          <BodyM mt="s100" textAlign="center" color="grey.700">
            <FormattedMessage id="pages.inventory.battery-management.modals.battery-damaged-reason.description" />
          </BodyM>
          <DropDown
            mt="s200"
            options={DAMAGE_TYPE_OPTIONS}
            value={selectedReason}
            onInput={(reason) => {
              setSelectedReason(reason as DamageType);
            }}
            filterMode={false}
            border="1px solid"
            borderColor="grey.800"
            borderRadius="8px"
            bgColor="white"
            titleColor="grey.800"
            w="100%"
            h="40px"
            placement="top"
            listStyles={{ w: "320px", maxH: "260px" }}
            listItemStyles={{ w: "320px", minHeight: "40px" }}
          >
            <BodyM color="grey.800">
              <FormattedMessage id="pages.inventory.battery-management.modals.battery-damaged-reason.placeholder" />
            </BodyM>
          </DropDown>
        </Modal.Body>
        <Modal.Footer p="0" mt="s200" flexDir="column" gap="s100">
          <Button
            isDisabled={!selectedReason}
            onClick={onClickPrimary}
            variant="primary"
            size="lg"
            isFullWidth
          >
            <FormattedMessage id="pages.inventory.battery-management.modals.battery-damaged-reason.cta.primary" />
          </Button>
          <Button onClick={onClickSecondary} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="pages.inventory.battery-management.modals.battery-damaged-reason.cta.secondary" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
